// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"37179b70","453":"46dc3e92","639":"0dc75407","701":"45086aba"}[chunkId] + ".chunk.js";
};